export default __webpack_public_path__ + "static/media/date_time.363ed4ea.svg";